import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class FileUtil {
    public getFileExtension(fileName: string): string {
        return fileName.split('.').pop() || '';
    }

    public getFileNameWithoutExtention(fileName: string): string {
        return fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
    }
}